<template>
  <div :id="videoName"></div>
</template>

<script>
import Player from "@vimeo/player";
export default {
  name: "vimeoPlayer",
  data: () => ({
    videoName: "vimeoFrame",
    newUrl: null,
    player: null,
  }),
  props: {
    id: {
      type: String,
      required: false,
    },
    url: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    playerHeight: {
      type: Number,
      default: 320,
    },
    playerWidth: {
      type: Number,
      default: 640,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.videoName = this.videoName + "_" + this.url.substring(this.url.length - 8);
  },
  mounted() {
    this.init();
  },
  methods: {
    reInit(video) {
      this.player
        .loadVideo(video)
        .then(function (id) {
          // the video successfully loaded
        })
        .catch(function (error) {
          switch (error.name) {
            case "TypeError":
              // the id was not a number
              break;

            case "PasswordError":
              // the video is password-protected and the viewer needs to enter the
              // password first
              break;

            case "PrivacyError":
              // the video is password-protected or private
              break;

            default:
              // some other error occurred
              break;
          }
        });
        this.player.on('progress', function() {
          console.log({progress: data});
        })
    },
    init() {
      
      // console.log("init");
      const options = {
        id: this.id,
        url: this.url,
        width: this.playerWidth,
        height: this.playerHeight,
        loop: this.loop,
        autoplay: this.autoplay,
        controls: this.controls,
        responsive: true,
      };
      if (this.url.value) {
        options.url = this.url.value;
      }
      this.player = new Player(this.videoName, options);
      
    },
  },
  watch: {
    url(newValue, oldValue) {
      this.reInit(newValue);
    },
  },
};
</script>